import { render } from "./AppAdvantages.vue?vue&type=template&id=64040662&scoped=true"
import script from "./AppAdvantages.vue?vue&type=script&lang=js"
export * from "./AppAdvantages.vue?vue&type=script&lang=js"

import "./AppAdvantages.vue?vue&type=style&index=0&id=64040662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64040662"]])

export default __exports__